export default {"src":"/_next/static/media/DXCM.917347be.svg","height":18,"width":18};